import React from "react";
import { useEffect, useState } from "react";
import {
  AmplifyProvider,
  Authenticator,
  useAuthenticator,
  useTheme as useAwsTheme,
  Button,
} from "@aws-amplify/ui-react";
import awsConfig from "../config/aws";
import { Amplify, Auth } from "aws-amplify";
import { useAppSelector } from "../redux/hooks";
import { LogoHcc } from "../svg/Logo";
import { breadcrumbSelector } from "../redux/slices/breadCrumb.slice";
import { RxHamburgerMenu } from "react-icons/rx";
import HccBreadCrumb from "./breadCrumb/HccBreadCrumb";
import Header from "./header/header";
import StateHandler from "./stateHandler/stateHandler";
import { Outlet } from "react-router-dom";

const isLocalhost = Boolean(
  window.location.hostname === "localhost" ||
    window.location.hostname === "[::1]" ||
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
);
const newConfig = {
  ...awsConfig,
  oauth: {
    ...awsConfig.oauth,
    redirectSignIn: isLocalhost
      ? awsConfig.oauth.redirectSignIn.local
      : awsConfig.oauth.redirectSignIn.deployed,
    redirectSignOut: isLocalhost
      ? awsConfig.oauth.redirectSignOut.local
      : awsConfig.oauth.redirectSignOut.deployed,
  },
};

const PROVIDER = "HertfordshireCountyCouncilAD";
Amplify.configure(newConfig);
const components = {
  SignIn: {
    Footer() {
      const { toResetPassword } = useAuthenticator();

      return (
        <div className="flex justify-between items-center px-[32px] pb-5 pt-0 text-center">
          <button onClick={toResetPassword}>Reset Password</button>
          <button
            onClick={() => Auth.federatedSignIn({ customProvider: PROVIDER })}
          >
            Sign in with SSO
          </button>
        </div>
      );
    },
  },
};
const awsTheme = {
  name: "Data inspired living",
};

const ProtectedRoute = () => {
  return (
    <AmplifyProvider theme={awsTheme}>
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Authenticator hideSignUp={true} components={components}>
          {() => (
            <div className="w-full min-h-screen">
              <StateHandler />
              <TopSection />
              <Outlet />
            </div>
          )}
        </Authenticator>
      </div>
    </AmplifyProvider>
  );
};

export default ProtectedRoute;

const TopSection = () => {
  const crumbs = useAppSelector((state) => breadcrumbSelector(state));

  const hideCrumbs = crumbs.length === 0;
  const [openNav, setOpenNav] = useState(false);
  return (
    <>
      <div className=" flex-col w-full md:flex hidden ">
        <Header openNav={openNav} setOpenNav={setOpenNav} />
        {!hideCrumbs && <HccBreadCrumb />}
      </div>
      <div className="flex-col w-full md:hidden flex">
        <div className="h-[80px] w-full bg-white border-0 border-b  border-solid border-breadCrumbGray2 flex md:hidden   items-center justify-between py-4 px-6  sm:px-8">
          <div className="cursor-pointer">
            <LogoHcc />
          </div>
          <RxHamburgerMenu
            onClick={() => setOpenNav(true)}
            className="text-4xl cursor-pointer"
          />
        </div>
        {!hideCrumbs && <HccBreadCrumb />}
      </div>
      <div
        className={`${
          openNav ? "flex" : "hidden"
        } md:hidden fixed top-0 left-0 bg-white  z-50 w-full h-screen `}
      >
        <Header openNav={openNav} setOpenNav={setOpenNav} />
      </div>
    </>
  );
};
